import script from "./empowerAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./empowerAddress.vue?vue&type=script&setup=true&lang=js"

import "./empowerAddress.vue?vue&type=style&index=0&id=1193111e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1193111e"]])

export default __exports__